import React from "react";
import "./About.css";
import portfolioPic1 from "../../assets/portfolioPic1.JPEG";
import { useTranslation } from "react-i18next";

const About = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div id={id} className="about">
        <h1 className="about-title">{t("about.title")}</h1>
        <div className="about-section">

          {/* Left picture */}
          <div className="about-left">
            <img src={portfolioPic1} alt="Profile" />
          </div>

          {/* Right content */}
          <div className="about-right">
            <div className="about-para">
              {/* Introduction */}
              <p>{t("about.body1")}</p>
              <br />
              <p>{t("about.body2")}</p>
              <p>{t("about.body3")}</p>
              <br />
              <p>{t("about.body4")}</p>
            </div>

            {/* Skills and achievements */}
            <div className="about-skills">
              <div className="about-skill">
                <p>HTML & CSS</p>
                <div className="skill-bar" style={{ width: "70%" }}></div>
              </div>

              <div className="about-skill">
                <p>React</p>
                <div className="skill-bar" style={{ width: "60%" }}></div>
              </div>

              <div className="about-skill">
                <p>JavaScript</p>
                <div className="skill-bar" style={{ width: "55%" }}></div>
              </div>

              <div className="about-skill">
                <p>TypeScript</p>
                <div className="skill-bar" style={{ width: "55%" }}></div>
              </div>

              <div className="about-skill">
                <p>C# .NET</p>
                <div className="skill-bar" style={{ width: "50%" }}></div>
              </div>

              <div className="about-skill">
                <p>Java</p>
                <div className="skill-bar" style={{ width: "40%" }}></div>
              </div>

              <div className="about-skill">
                <p>Python</p>
                <div className="skill-bar" style={{ width: "30%" }}></div>
              </div>

              <div className="about-skill">
                <p>SQL</p>
                <div className="skill-bar" style={{ width: "20%" }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Achievements */}
        <div className="about-achievements">
          <div className="about-achievement1">
            <h1>10+</h1>
            <p>{t("about.achievements.experience")}</p>
          </div>
          <hr />
          <div className="about-achievement2">
            <h1>3+</h1>
            <p>{t("about.achievements.projects")}</p>
          </div>
        </div>
      </div>
  );
};

export default About;
